import React from "react";
import { Button, Box, useMediaQuery } from "@mui/material";
import thankreferral from "../assets/Thankyou.png";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const Thankreferral = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const location = useLocation();
  const { clientId, firstname, lastname } = location.state || {};
  const navigate = useNavigate();

  const handlenext = () => {
    navigate("/referraldetails", { state: { clientId } });
  };

  const handleCancel = () => {
    console.log("handle cancel");
  };

  return (
    <>
      {isSmallScreen ? (
        <span>
          <Box sx={styles.formboxres}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <img src={thankreferral} alt="logo" />
            <Typography
              sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "4px" }}
            >
              Thank you for the reference!
            </Typography>
            {/* <div style={{ color: "gray" }}>
        Our team member will contact at the earliest.
      </div> */}
            {/* Display firstname and lastname of the last user */}
            {firstname && lastname && (
              <div style={{ color: "gray" }}>
                Our team member will contact {firstname} {lastname} at the
                earliest.
                {/* <Typography>{`Firstname: ${lastUser.firstname}`}</Typography>
          <Typography>{`Lastname: ${lastUser.lastname}`}</Typography> */}
              </div>
            )}
            <Button sx={styles.btn} onClick={handlenext}>
              Let's Continue
            </Button>
          </Box>
        </span>
      ) : (
        <span>
          <Box sx={styles.formbox}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <img src={thankreferral} alt="logo" />
            <Typography
              sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "4px" }}
            >
              Thank you for the reference!
            </Typography>
            {/* <div style={{ color: "gray" }}>
        Our team member will contact at the earliest.
      </div> */}
            {/* Display firstname and lastname of the last user */}
            {firstname && lastname && (
              <div style={{ color: "gray" }}>
                Our team member will contact {firstname} {lastname} at the
                earliest.
                {/* <Typography>{`Firstname: ${lastUser.firstname}`}</Typography>
          <Typography>{`Lastname: ${lastUser.lastname}`}</Typography> */}
              </div>
            )}
            <Button sx={styles.btn} onClick={handlenext}>
              Let's Continue
            </Button>
          </Box>
        </span>
      )}
    </>
  );
};

export default Thankreferral;

const styles = {
  formbox: {
    position: "absolute",
    top: "51%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "350px",
    width: "420px",
  },
  formboxres: {
    position: "absolute",
    top: "51%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "350px",
    width: "320px",
  },
  btn: {
    margin: "2em 0em 2em 0em",
    width: "12em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
